import React, { useState, useEffect } from "react";
import _CONFIG_ from "config/Constant";

const importAll = (r) => r.keys().map(r);

const allImages = {
  slots: importAll(
    require.context(
      "assets/images/slots",
      false,
      /\.(jpg|jpeg|png|gif|webp)$/,
      "lazy"
    )
  ),
  sports: importAll(
    require.context(
      "assets/images/sports",
      false,
      /\.(jpg|jpeg|png|gif|webp)$/,
      "lazy"
    )
  ),
  lottery: importAll(
    require.context(
      "assets/images/lottery",
      false,
      /\.(jpg|jpeg|png|gif|webp)$/
    ),
    "lazy"
  ),
  casino: importAll(
    require.context(
      "assets/images/casino",
      false,
      /\.(jpg|jpeg|png|gif|webp)$/,
      "lazy"
    )
  ),
};

const Games = ({ type, limit = 100 }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      const loadedImages = await Promise.all(allImages[type]);
      setImages(loadedImages);
    };

    loadImages();
  }, [type]);
  const uniqueImages = [...new Set(images)];

  return (
    <ul className="flex flex-wrap g-20">
      {uniqueImages.slice(0, limit).map((slide, i) => {
        return (
          <li key={i}>
            <a href={_CONFIG_.REGISER_URL} rel="noindex nofollow">
              <img
                src={slide}
                alt={slide.alt ?? `Slide ${i}`}
                key={i}
                style={{ width: "150px", height: "auto", borderRadius: "8px" }}
                loading={i > 0 ? "lazy" : "eager"}
              />
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default Games;
